export const environment = {
  production: false,
  apiUrlOCSP: 'https://pqavocs.ircnl.gob.mx/',
  apiUrlDocumentos: 'https://misiqa.ircnl.gob.mx/misiqa/',
  apiUrlFirma: 'https://misiqa.ircnl.gob.mx/misiqa/',
};
